import { render, staticRenderFns } from "./PaymentBillPayU.vue?vue&type=template&id=3824dcd4&"
import script from "./PaymentBillPayU.vue?vue&type=script&lang=js&"
export * from "./PaymentBillPayU.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports